
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBackwards10s as ObiBackwards10sElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-backwards-10s.js';
 
 
 

 
 export const ObiBackwards10s = createComponent({
   react: React,
   tagName: 'obi-backwards-10s',
   elementClass: ObiBackwards10sElement,
   events: {
     
   }
  });
 
 